import { helper } from '@ember/component/helper';

export default helper(function isOdd([number]) {
  return number % 2 === 1;
});
